import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

// Add New Customers
export const addNewCustomers = createAsyncThunk(
  "add-new-customers/addNewCustomers",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/add-or-update-customer", payload);
      // console.log("The res of adding new customers from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);

export const getAllCustomers = createAsyncThunk(
  "add-new-customers/getAllCustomers",
  async (
    { page = 1, search = "", page_type = "all customers", filter = "all" },
    { rejectWithValue },
  ) => {
    try {
      const res = await axiosInstance.get("/customer-list", {
        params: {
          page,
          search,
          page_type,
          filter,
        },
      });
      // console.log("the res for customer list from thunk is ", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);

export const getCustomerDetailById = createAsyncThunk(
  "add-new-customers/getCustomerDetailById",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/get-customer-detail", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);
